// create manipulation sliders
var size_range, rot_range, pos_x_range, pos_y_range, int_int, ctr_sliders,  ctr_tgt = 0, ctr_visible = false;
var obj_tgt = ['#TEAM_NAME_-_JERSEY div', '.TEAM_LOGO div', '#TEAM_NAME_-_PANT div', '.TEAM_LOGO_PANT div'],
ctr_vals=[[1, 0, 0, 0], [1, 0, 0, 0], [1, 0, 0, 0], [1, 0, 0, 0]];

var rx_range = [{'min': -343, 'max': 115}, {'min': -133, 'max': 325}, {'min': -100, 'max': 320}, {'min': -133, 'max': 325}]
var ry_range = [{'min': -50, 'max': 135}, {'min': -50, 'max': 155}, {'min': -100, 'max': 225}, {'min': -100, 'max': 225}]
				//    jersey text					jersey logo				pants text					pants logo

	function chekFileType() {

		var def_ext = 'else';
		var ext = this.value.split('.').slice(-1).pop()

		switch (ext) {
			case 'png':
			    def_ext = 'png'
				break;
			case 'jpg':
				def_ext = 'jpg'
				break;
			case 'svg':
				def_ext = 'svg'
				break; 
		}

		if(def_ext == 'else') {
			alert('Only png, jpg or svg files are allowed !');
			this.value = '';
		} else {

			$('.TEAM_LOGO div').remove();
            
			
			ctr_tgt = 2
			$('[name=ctr-rad]').eq(ctr_tgt).prop('checked', true);
			ctr_vals[ctr_tgt] = [1, 0, 0, 0];

			ctr_sliders.forEach(function(e, i) {
				console.log(ctr_vals[ctr_tgt])
				e.noUiSlider.set(ctr_vals[ctr_tgt][i])
				$('.noUi-tooltip').hide();
			})
		}
	}


	function fitTeamNames(){

			var fhf = $('.team-name:eq(0) div').height();
			var fwf = $('.team-name:eq(0) div').width();
			
			$('.team-name:eq(0) div').css({
				'margin-top': 0,
				'margin-left': -fwf/2
			})	

			var fh = $('.team-name:eq(1) div').height();
			var fw = $('.team-name:eq(1) div').width();

			$('.team-name:eq(1) div').css({
				'margin-top':-fh*font_align[font_id]/100,
				'margin-left': 0
			})		

	}

	function setObjPosition() {

		var val = ctr_vals[ctr_tgt]

		$(obj_tgt[ctr_tgt]).css({
			'transform': 'scale('+val[0]+') rotate('+val[1]+'deg)',
			'left': val[2],
			'top': val[3]
		})

	}

	function createManipulationUI() {      

		$('#q-file').imageLoader({
				'show': '.u-logo'
		});
      

		$('#q-file').change(chekFileType);



		// reset objects size and position

		// TEAM NAME FRONT

		$('#team-input').bind('keyup',fitTeamNames)

		$('#TEAM_NAME_-_JERSEY').css({
			'width': 0,
			'height': 0,
			'left': 510,
			'top': 140
		})

		$('#TEAM_NAME_-_JERSEY div').css({
			'position': 'absolute',
			'margin-top': 0,
			'left': 0,
			'top': 0
		})

		$('#TEAM_NAME_-_PANT').css({
			'width': 0,
			'height': 0,
			'left': 230,
			'top': 422
		})

		$('#TEAM_NAME_-_PANT div').css({
			'position': 'absolute',
            'margin-top': 0,
			'left': 0,
			'top': 0
		})


		fitTeamNames();


		///////////////////////////////////////


		// size control

		size_range = document.getElementById('set-size')

		noUiSlider.create(size_range, {
			start: 1 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'ltr', // Put '0' at the bottom of the slider
			orientation: 'horizontal', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 0.1,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(1);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': 0.1,
				'max': 4
			}
		});

		$(size_range).find('.noUi-tooltip').hide();

		size_range.noUiSlider.on('update', function( values ) {
			$(size_range).find('.noUi-tooltip').show();
			ctr_vals[ctr_tgt][0] = size_range.noUiSlider.get();
			setObjPosition();
		})

		size_range.noUiSlider.on('change', function( values ) {

			$(size_range).find('.noUi-tooltip').hide();
			ctr_vals[ctr_tgt][0] = size_range.noUiSlider.get();
			setObjPosition();
		})

		// rotation control

		rot_range = document.getElementById('set-rot')

		noUiSlider.create(rot_range, {
			start: 0 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'ltr', // Put '0' at the bottom of the slider
			orientation: 'horizontal', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 10,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(0);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': -180,
				'max': 180
			}
		});

		$(rot_range).find('.noUi-tooltip').hide();

		rot_range.noUiSlider.on('update', function( values ) {
			$(rot_range).find('.noUi-tooltip').show();
			ctr_vals[ctr_tgt][1] = parseInt(rot_range.noUiSlider.get());
			setObjPosition();
		})

		rot_range.noUiSlider.on('change', function( values ) {
			$(rot_range).find('.noUi-tooltip').hide();
			ctr_vals[ctr_tgt][1] = parseInt(rot_range.noUiSlider.get());
			setObjPosition();
		})

		// position control

		pos_x_range = document.getElementById('set-posx')

		noUiSlider.create(pos_x_range, {
			start: 0 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'ltr', // Put '0' at the bottom of the slider
			orientation: 'horizontal', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 1,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(0);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': -133,
				'max': 325
			}
		});

		$(pos_x_range).find('.noUi-tooltip').hide();

		pos_x_range.noUiSlider.on('update', function( values ) {
			$(pos_x_range).find('.noUi-tooltip').show();
			ctr_vals[ctr_tgt][2] = parseInt(pos_x_range.noUiSlider.get());
			setObjPosition();
		})

		pos_x_range.noUiSlider.on('change', function( values ) {
			$(pos_x_range).find('.noUi-tooltip').hide();
			ctr_vals[ctr_tgt][2] = parseInt(pos_x_range.noUiSlider.get());
			setObjPosition();
		})

		$('.set-holder').find('.noUi-tooltip').hide();



		pos_y_range = document.getElementById('set-posy')

		noUiSlider.create(pos_y_range, {
			start: 0 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'ltr', // Put '0' at the bottom of the slider
			orientation: 'vertical', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 1,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(0);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': -50,
				'max': 225
			}
		});

		$(pos_y_range).find('.noUi-tooltip').hide();

		pos_y_range.noUiSlider.on('update', function( values ) {
			$(pos_y_range).find('.noUi-tooltip').show();
			ctr_vals[ctr_tgt][3] = parseInt(pos_y_range.noUiSlider.get());
			setObjPosition();
		})

		pos_y_range.noUiSlider.on('change', function( values ) {
			$(pos_y_range).find('.noUi-tooltip').hide();
			ctr_vals[ctr_tgt][3] = parseInt(pos_y_range.noUiSlider.get());
			setObjPosition();
		})

		$('.set-holder').find('.noUi-tooltip').hide();

		ctr_sliders = [];
		ctr_sliders.push(size_range, rot_range, pos_x_range, pos_y_range)
        

		// select manipulated object
        
        $('#ctr-close').click(function() {
        	$('.ctr-open').removeClass('ctr-selected');
          	$('#ctr-holder').stop().clearQueue();
          	$('#ctr-holder').animate({height: 0}, 300);
        })

		$('.ctr-open').click(function() {
			
          	$('.ctr-open').not(this).removeClass('ctr-selected');
          
			ctr_tgt = $(this).attr('id').split('-')[1];

          	
          	
            var ctr_top = $(this).attr('m-pos');

			ctr_sliders.forEach(function(e, i) {
				e.noUiSlider.set(ctr_vals[ctr_tgt][i])
				$('.noUi-tooltip').hide();
			})
            
            pos_x_range.noUiSlider.updateOptions({range: rx_range[ctr_tgt]});
            pos_y_range.noUiSlider.updateOptions({range: ry_range[ctr_tgt]});
            
            $('#ctr-holder').stop().clearQueue();
          	
          
          	if ($(this).hasClass('ctr-selected')) {
              
              $('#ctr-holder').animate({height: 0}, 300);
              $(this).removeClass('ctr-selected');
          
            } else {
              
            	$('#ctr-holder').css({'top': ctr_top + 'px'}).animate({height: 185}, 300);
              	$(this).addClass('ctr-selected');
            }
          
            
		})
        
        var query = window.location.href.indexOf('#')!=-1?window.location.href.split('#')[1]:window.location.href.split('=')[1]

        if(query==undefined || query==''){
            ctr_vals=[[1, 0, 0, 0], [1, 0, 0, 0], [1, 90, -33, -15], [1, 0, 0, 0]];
        }else{
            var cv = dparts[10].split('_')
            ctr_vals = [];
            ctr_vals = [
              [cv[0],cv[1],cv[2],cv[3]],
              [cv[4],cv[5],cv[6],cv[7]],
              [cv[8],cv[9],cv[10],cv[11]],
              [cv[12],cv[13],cv[14],cv[15]]
            ];
        }
        
        for(j=0; j<obj_tgt.length; j++) {
          
          ctr_tgt = j;
        
          ctr_sliders.forEach(function(e, i) {
            
            e.noUiSlider.set(Number(ctr_vals[ctr_tgt][i]))
            $('.noUi-tooltip').hide();
            
          })
          
        }
      
        setTimeout(fitTeamNames, 500);
            
	}
